module.exports = __webpack_public_path__ + "img/fcc-compare-adjusters-screen.5552281b.png";